function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Mobilephone({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 1c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2H7c-1.104 0-2-.897-2-2V3c0-1.103.896-2 2-2h10.5zm.001 17.394h-10.5V21h10.5v-2.606zm-5.299.36a.95.95 0 11.001 1.9.95.95 0 010-1.9zM17.5 6.371H7v10.022h10.501V6.372zM17.5 3H7v1.372h10.5V3z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoMobilephone = React.memo(Mobilephone);
export default MemoMobilephone;